import React from "react";
import { resources } from "../data/siteData";

function ResourcesSection() {
  return (
    <section id="resources" className="section resources">
      <div className="resources__head center">
        <p className="eyebrow center">Resources</p>
        <h2 className="center">Insights for the modern clinic.</h2>
        <p className="center">
          Practical guides, compliance updates, and ideas to help your clinic run
          better.
        </p>
      </div>
      <div className="resources__grid">
        {resources.map((item) => (
          <article className="resources__card" key={item.title}>
            <p className="resources__cat">{item.cat}</p>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ResourcesSection;
